import { createFileRoute } from "@tanstack/react-router";
import BuilderPortalLayout from "lib/components/builders/BuilderPortalLayout";
import SalesCategoryCustomization from "lib/components/builders/marketing/SalesCategoryCustomization";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../components/withAuthentication";

const MarketingPage = () => {
  const { builderId } = useAppRouterParams();

  return (
    <BuilderPortalLayout header="Marketing" selected="marketing" pageTitle="Marketing">
      <div className="builder-portal-layout-content">
        <SalesCategoryCustomization builderId={builderId} />
      </div>
    </BuilderPortalLayout>
  );
};

export const Route = createFileRoute("/builders/$builder_id/marketing/")({
  component: withAuthentication(MarketingPage, { permissions: ["VIEW_SALES_CATEGORIES"] }),
});
